"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
class ShopwareCategories {
    api = new ecommerce_1.CategoryApi(configuration_1.default);
    loading = false;
    initialized = false;
    categories = [];
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            loading: mobx_1.observable,
            initialized: mobx_1.observable,
            categories: mobx_1.observable,
            isLoading: mobx_1.computed,
            isInitialized: mobx_1.computed,
        });
    }
    initialize() {
        if (this.initialized || this.loading) {
            return Promise.resolve();
        }
        this.loading = true;
        return this.loadCategories()
            .then((0, mobx_1.action)((categories) => {
            this.categories = categories;
        }))
            .finally((0, mobx_1.action)(() => {
            this.loading = false;
            this.initialized = true;
        }));
    }
    reset() {
        this.initialized = false;
        this.categories = [];
    }
    get isLoading() {
        return this.loading;
    }
    get isInitialized() {
        return this.initialized;
    }
    getCategory(categoryId) {
        return this.categories.find((category) => category.id === categoryId);
    }
    loadCategories(page = 1, limit = 500) {
        return this.api
            .readCategories({
            requestBody: {
                page,
                limit,
                totalCountMode: ecommerce_1.RequestBodyTotalCountModeEnum.NUMBER_1,
                associations: {
                    massiveCategory: {
                        ' ': 1,
                    },
                },
            },
        })
            .then((list) => {
            const categories = list.elements ?? [];
            const totalLoaded = (page - 1) * limit + categories.length;
            return totalLoaded < (list.total ?? 0)
                ? this.loadCategories(page + 1, limit).then((nextCategories) => [...categories, ...nextCategories])
                : categories;
        });
    }
}
exports.default = new ShopwareCategories();
